<template>
  <div class="card">
    <img :src="imgUrl" class="img_card_component"/>
  </div>
</template>

<script>

export default {
  components: {},
  name: "Card",
  props: {
    imgUrl: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.card {
  border-radius: 20px; /* 5px rounded corners */
  border: 0px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100% ;
  padding: 20px;
}
.img_card_component {
  width: 100%;
  height: 100%;
}
</style>